// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

/**
 * Rounded-triangle alert/danger icon (iconsax "Danger" style) used in the
 * Rejection Reason modal header. Stroke-based so it inherits the header
 * colour via {@code currentColor}. Uses {@link React.useId} for unique
 * clip/mask ids so multiple instances on the same page don't collide.
 */
const RejectionAlertIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;
  const stroke = color || 'currentColor';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask
          id={maskId}
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path d="M24 0H0V24H24V0Z" fill="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d="M12 9V14"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9995 21.4093H5.93944C2.46944 21.4093 1.01944 18.9293 2.69944 15.8993L5.81945 10.2793L8.75945 4.9993C10.5395 1.7893 13.4595 1.7893 15.2395 4.9993L18.1795 10.2893L21.2995 15.9093C22.9795 18.9393 21.5195 21.4193 18.0595 21.4193H11.9995V21.4093Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9941 17H12.0031"
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { RejectionAlertIcon };
